<template>
	<div class="risk_input">
		<van-field
			class="risk_input-item"
			type="number"
			:border="false"
			v-for="(item,index) in options"
			:key="index"
			v-model="item.value"
			:placeholder="item.placeholder"
		>
			<template #right-icon>
				{{item.rightText}}
			</template>
		</van-field>
		<!-- <van-number-keyboard
            v-model="value"
            :show="show"
            :maxlength="6"
            @blur="show = false"
        /> -->
	</div>
</template>
<script>
export default {
    props: {
        options: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            // show:false
        }
    },

    methods: {
        // changeValue(item){
        //     this.show = true
        // }
    }
}
</script>
<style lang="less">
.risk_input {
	&-item {
		height: 120px;
		border-radius: 16px;
		border: 1px solid #f7f7f7;
		background: #f7f7f7;
		margin-bottom: 26px;
		font-size: 30px;
		line-height: 120px;
		padding: 0 32px;
	}
	&-item:last-of-type {
		margin-bottom: 0px;
	}
}
</style>